export enum SortByDirectionEnum {
    ASC = 1,
    DESC = 2
}